<template>
  <div >
  <h2 class="categories-wrapper-title " :class="{'brand-color':!isPhone}">{{ $t("by_market_filter") }}</h2>
  <a href="javascript:;" class="columns is-mobile card-wrapper" @click="$root.$emit('remove-market-filter')" >
    <div class="card column">
      <div class="columns is-mobile">
        <div class="column image-col">
          <figure class="image is-128x128" :style="'background-image:url('+marketPicture(market)+')'">

          </figure>
        </div>
        <div class="column name">{{market.label.normalize('NFD').replace(/[\u0300-\u036f]/g, "")}}</div>
      </div>
    </div>
    <span class="column"><i class="fa fa-times-circle"></i></span>
  </a>
  </div>

</template>

<script>

import {mapState} from "vuex";

export default {
name: "MarketSelected",

  props : {
    market: {
      type:Object,
      require:true,
      default : null
    },
  },
  computed: {
    ...mapState({
      isPhone: state => state.settings.isPhone,
    }),
  },
  methods : {
    marketPicture(market) {
      try {
        return require(`@/assets/img/markets/${market.code}.jpg`)
      } catch (e) {
        return null
      }
    },
  }


}
</script>

<style scoped lang="scss">
.card-wrapper {
  margin-bottom:15px;
}
.card {
  border-radius:80px;
  box-shadow:2px 2px 5px rgba(0,0,0,0.3);

  background:$light-grey;
}
.columns {align-items: center!important}
.card {
  flex:1;
  display:block;
  .column {padding:0.5rem;}
  .column.image-col {
    flex: 0 0 calc(70px);
    display: block;
    @media #{$mq_tablet} {
      display:none
    }
    @media #{$mq_phone} {
      display:block
    }
  }

  .column.name {
    flex: 1;
    font-weight: bold;
   // font-family: Manitou;
    font-size: 13px;
    color: $brand-red;
    text-transform: uppercase;
    text-align:left;
    @media #{$mq_tablet} {
      text-align:center;
      padding:0.75rem;
    }
    @media #{$mq_phone} {
      text-align:left;
      padding:0.5rem;
    }
  }
}
  .column:last-child {
    flex:0 0 calc(30px);
    font-size:20px;
    text-align:right;
  }

  .image {
    width:40px;
    height:40px;
    background-size:cover;
    border-radius:100%
  }

</style>